import Axios from 'axios';

export default {
  getTendenciasProductos(params = {}) {
    // Construir query string dinámicamente
    const queryParams = new URLSearchParams();
    
    if (params.fechaInicio) queryParams.append('fechaInicio', params.fechaInicio);
    if (params.fechaFin) queryParams.append('fechaFin', params.fechaFin);
    if (params.regionMuestra) queryParams.append('regionMuestra', params.regionMuestra);
    if (params.region) queryParams.append('region', params.region);
    if (params.orden) queryParams.append('orden', params.orden);
    if (params.empresa) queryParams.append('empresa', params.empresa);
    
    const queryString = queryParams.toString();
    const endpoint = queryString ? `conveniomarco/tendencias-productos?${queryString}` : 'conveniomarco/tendencias-productos';
    
    return Axios.get(endpoint);
  },

  async exportarTendenciasExcel(params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.fechaInicio) queryParams.append('fechaInicio', params.fechaInicio);
    if (params.fechaFin) queryParams.append('fechaFin', params.fechaFin);
    if (params.regionMuestra) queryParams.append('regionMuestra', params.regionMuestra);
    if (params.region) queryParams.append('region', params.region);
    if (params.orden) queryParams.append('orden', params.orden);
    if (params.empresa) queryParams.append('empresa', params.empresa);
    
    const queryString = queryParams.toString();
    const endpoint = queryString ? `conveniomarco/tendencias-productos-excel?${queryString}` : 'conveniomarco/tendencias-productos-excel';

    const response = await Axios({
      url: endpoint,
      method: 'GET',
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    
    // Nombre del archivo basado en filtros
    const fechaStr = params.fechaInicio ? `_${params.fechaInicio}_${params.fechaFin || params.fechaInicio}` : '';
    const regionStr = params.regionMuestra ? `_${params.regionMuestra}` : '';
    const empresaStr = params.empresa ? `_${params.empresa.replace(/\s+/g, '')}` : '';
    
    link.setAttribute('download', `TendenciasCM${fechaStr}${regionStr}${empresaStr}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}